import React from 'react'
import PropTypes from 'prop-types'

function withLoader (Placeholder) {
    return function (WrappedComponent) {
        class LoaderWrapper extends React.Component {
            static propTypes = {
                isLoading: PropTypes.bool,
                isAvailable: PropTypes.bool,
            }

            static defaultProps = {
                isLoading: true,
                isAvailable: true,
            }
            render () {
                const { isLoading, isAvailable, ...restProps } = this.props

                return (
                    isLoading || !isAvailable
                        ? <Placeholder />
                        : <WrappedComponent {...restProps} />
                )
            }
        }

        return LoaderWrapper
    }
}

export default withLoader
